import React from "react";
import { ArrowLeft, Shield } from "lucide-react";
import { Logo } from "../components/site/Logo";
import { CONTACT } from "../data/hseData";

export default function PrivacyPage() {
  const sections = [
    {
      h: "1. Quem somos",
      p: "A HSE Soluções e Serviços é uma empresa brasileira fundada em 2006, especializada em segurança do trabalho, meio ambiente, treinamentos, serviços industriais críticos, manutenção em altura, espaço confinado, resgate técnico e resposta a emergências.",
    },
    {
      h: "2. Dados que coletamos",
      p: "Coletamos apenas os dados necessários para atender solicitações comerciais e técnicas enviadas pelo formulário de contato: nome, empresa, telefone/WhatsApp, e-mail, cidade/estado, serviço de interesse, descrição da necessidade e nível de urgência.",
    },
    {
      h: "3. Finalidade do tratamento",
      p: "Os dados são utilizados exclusivamente para: (i) entender a necessidade do interessado; (ii) elaborar propostas técnicas e comerciais; (iii) prestar suporte a operações críticas contratadas; (iv) cumprir obrigações legais aplicáveis.",
    },
    {
      h: "4. Base legal (LGPD)",
      p: "O tratamento dos dados ocorre com fundamento no consentimento do titular (art. 7º, I da Lei nº 13.709/2018 - LGPD), na execução de contrato ou procedimentos preliminares (art. 7º, V), e no legítimo interesse (art. 7º, IX).",
    },
    {
      h: "5. Compartilhamento",
      p: "A HSE não comercializa dados pessoais. As informações podem ser compartilhadas apenas com colaboradores internos envolvidos no atendimento, e com autoridades competentes quando exigido por lei.",
    },
    {
      h: "6. Armazenamento e segurança",
      p: "Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, perda ou alteração. Os dados são armazenados em ambiente seguro e retidos apenas pelo tempo necessário à sua finalidade.",
    },
    {
      h: "7. Direitos do titular",
      p: "Nos termos da LGPD, o titular pode solicitar a qualquer momento: confirmação da existência de tratamento, acesso, correção, anonimização, bloqueio ou eliminação de dados, portabilidade e revogação do consentimento. As solicitações devem ser enviadas para " + CONTACT.email + ".",
    },
    {
      h: "8. Cookies",
      p: "O site utiliza cookies essenciais para o funcionamento e cookies de análise para melhorar a experiência de navegação. O usuário pode aceitar ou rejeitar cookies não essenciais através do banner exibido no primeiro acesso.",
    },
    {
      h: "9. Alterações desta política",
      p: "Esta política pode ser atualizada periodicamente. Recomendamos consultá-la de tempos em tempos. A versão vigente é sempre a publicada nesta página.",
    },
    {
      h: "10. Contato",
      p: `Para dúvidas sobre esta política ou o tratamento de dados pessoais, entre em contato: ${CONTACT.email} · ${CONTACT.address}.`,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0B1B2D] text-white">
      <header className="bg-black/85 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <Logo size="md" />
          <a
            href="/"
            data-testid="privacy-back"
            className="inline-flex items-center gap-2 font-condensed uppercase text-xs tracking-[0.2em] font-bold text-white/70 hover:text-white"
          >
            <ArrowLeft size={14} /> Voltar ao site
          </a>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-5 sm:px-8 py-16">
        <div className="inline-flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-[#2FA36B] flex items-center justify-center">
            <Shield size={18} className="text-white" />
          </div>
          <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">LGPD · Lei 13.709/2018</span>
        </div>
        <h1 className="font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
          Política de <span className="text-[#2FA36B]">Privacidade</span>
        </h1>
        <p className="mt-4 font-body text-white/60 text-sm">
          Última atualização: {new Date().toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" })}
        </p>

        <div className="mt-12 space-y-8">
          {sections.map((s, i) => (
            <section key={s.h} data-testid={`privacy-section-${i}`} className="border-l-2 border-[#2FA36B]/40 pl-6">
              <h2 className="font-condensed font-bold uppercase text-lg sm:text-xl text-white tracking-tight leading-tight mb-2">
                {s.h}
              </h2>
              <p className="font-body text-white/75 text-sm sm:text-base leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-16 border border-[#2FA36B]/40 p-6 bg-[#12283F]">
          <p className="font-body text-white/85 text-sm leading-relaxed">
            Ao utilizar este site e enviar dados pelo formulário de contato, você declara estar ciente e concordar com esta Política de Privacidade e com o tratamento de dados conforme a Lei Geral de Proteção de Dados (LGPD).
          </p>
        </div>
      </main>

      <footer className="border-t border-white/10 py-8 text-center">
        <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} HSE Soluções e Serviços</p>
      </footer>
    </div>
  );
}
